class BESSAppProjectCategoryNotes extends BESSAppBase {

    constructor() {
        super();
        this.node = $('.app-category-annotate');
        if (this.node.length === 0) {
            return;
        }
        this.annotateSelector = this.node.find('.form-check-input');
        this.annotationNote = $('.app-category-annotation');
        this.annotationNoNote = $('.app-category-annotate-no-note');
        this.annotationEditNote = $('.app-category-edit-annotation');
        this.onSelected(this.annotationEditNote, this.editReason);

        this.annotateSelector.change(this.updateState.bind(this));

        this.isAnnotate = this.annotateSelector.isChecked();
        $('body').addClassIf('app-category-annotated', this.isAnnotate);
    }


    getAnnotationNote() {
        return this.annotationNote.text().trim();
    }

    setAnnotationNote(reason) {
        this.annotationNote.html(reason.trim());
        this.annotationNoNote.showIf(reason.trim().length === 0);
    }

    updateState() {

        if (this.annotateSelector.isChecked() && this.getAnnotationNote().length === 0) {
            this.annotateSelector.setCheckedIf(false);
            this.editReason();
        } else {
            this.save();
        }
    }

    editReason() {
        this.askForDescriptiveTextInput(
            "Annotate",
            "<p>Add note for " + $('.app-category-title').text().trim() + ". All notes appear in the BESS report.</p>",
            this.getAnnotationNote(),
            function (reason) {
                this.setAnnotationNote(reason);
                this.annotateSelector.setCheckedIf(reason && reason.trim().length > 0);
                this.save();
            }
        );
    }

    save() {
        this.isAnnotate = this.annotateSelector.isChecked();
        $('body').addClassIf('app-category-annotated', this.isAnnotate);

        let annotateReason = this.getAnnotationNote();
        BESSApp.instance.services.api.project.apiUpdateCategoryAnnotation(this.isAnnotate, annotateReason);
    }
}